







































import { Donation } from '@/interfaces/donation/donation';
import Vue from 'vue';

export default Vue.extend({
  props: {
    donation: {
      type: Object as () => Donation,
      required: true,
    },
    displayAdminFee: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    adminAmount(): number {
      return this.donation.paymentSpecification.adminAmount
        ? this.donation.paymentSpecification.adminAmount
        : 0;
    },
    totalAmount(): number {
      return parseInt(this.donation.paymentSpecification.causeAmount) + this.adminAmount;
    },
    showAdminFee(): boolean {
      return (
        this.displayAdminFee &&
        this.donation.paymentSpecification &&
        this.donation.paymentSpecification.adminAmount &&
        this.donation.paymentSpecification.adminAmount > 0
      );
    },
  },
});
